import { DataService } from './dataService'
export const telerService = {
	getOnlinePaymentList: async (data) => {
		return DataService.get('/admin/get-online-payment-list', data)
	},
 
}

export default telerService